<script lang="ts">
	import { getContext } from 'svelte';
	import type { Writable } from 'svelte/store';
	import SearchInput from './LpgComponents/SearchInput.svelte';
	import type { IEventFilterSelectionsStore } from '@stores/eventFilterSelections';
	import type { IEventStore } from '@stores/event';

	let className = '';
	export { className as class };

	const eventFilterSelections = getContext<Writable<IEventFilterSelectionsStore>>(
		'eventFilterSelectionsStore'
	);
	const eventStore = getContext<Writable<IEventStore>>('eventStore');

	let value = $eventFilterSelections.eventTicketsSearchText;
</script>

<SearchInput
	id="ticket-search-term-input"
	bind:value
	on:search={(e) => {
		$eventFilterSelections.eventTicketsSearchText = e.detail.value;
	}}
	label="Suche"
	placeholder="Suchen Sie nach einem Ort"
	class={className}
	isLoading={$eventStore.loadingState}
/>
